export enum Tabs {
  TimeMaterials = 'Time & materials',
  FixedFeed = 'Fixed Fee',
  NonBillable = 'Non - Billable',
}
